import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

// Material
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
Vue.use(VueMaterial)

// Cookies
import VueCookies from 'vue-cookies'
VueCookies.config('7d')
Vue.use(VueCookies)

// Router
import router  from './router/index'

new Vue({
  router,
  render : h => h(App)
}).$mount('#app')
